import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  MODAL_CLIENT_CREATE_CYCLE,
  MODAL_CLIENT_CANCEL_TRANSACTION,
  MODAL_CLIENT_SELECTION_TRANSFERT
} from 'redux/modules/modals'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import AvPlay from '@material-ui/icons/PlayCircleFilled'
import AvPause from '@material-ui/icons/PauseCircleFilled'
import ReceiptIcon from '@material-ui/icons/Receipt'
import SwapIcon from '@material-ui/icons/SwapHoriz'
import AlarmAdd from '@material-ui/icons/AlarmAdd'
import DeleteIcon from '@material-ui/icons/Delete'
import * as Colors from '@material-ui/core/colors'
const runningColor = Colors.lightGreen['500']
const pauseColor = Colors.orange['400']
const styles = theme => ({
  button: {
    margin: 10
  },
  playButton: {
    margin: 10,
    backgroundColor: runningColor,
    '&:hover': {
      backgroundColor: Colors.lightGreen['700']
    }
  },
  pauseButton: {
    margin: 10,
    backgroundColor: pauseColor,
    '&:hover': {
      backgroundColor: Colors.orange['600']
    }
  }
})
class ActionsTableComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    showModal: PropTypes.func.isRequired,
    transaction: PropTypes.object.isRequired,
    playTransaction: PropTypes.func.isRequired,
    pauseTransaction: PropTypes.func.isRequired,
    prepareForPayment: PropTypes.func.isRequired
  }

  play = e => {
    this.props.playTransaction(this.props.transaction)
  }
  pause = e => {
    this.props.pauseTransaction(this.props.transaction)
  }
  addCycle = e => {
    this.props.showModal(MODAL_CLIENT_CREATE_CYCLE, this.props.transaction)
  }
  handleTransfertClick = e => {
    this.props.showModal(
      MODAL_CLIENT_SELECTION_TRANSFERT,
      this.props.transaction
    )
  }
  cancelTransaction = e => {
    this.props.showModal(
      MODAL_CLIENT_CANCEL_TRANSACTION,
      this.props.transaction
    )
  }
  handlePaymentClick = e => {
    this.props.prepareForPayment(this.props.transaction)
  }
  render() {
    const { classes, transaction } = this.props
    const disabled = transaction.paymentReady
    let playBtn = !transaction.pool.isPaused ? (
      <Button
        disabled={disabled}
        className={classes.pauseButton}
        variant="raised"
        onClick={this.pause}
        color="primary">
        <AvPause color="inherit" />
      </Button>
    ) : (
      <Button
        disabled={disabled}
        className={classes.playButton}
        variant="raised"
        onClick={this.play}
        color="secondary">
        <AvPlay color="inherit" />
      </Button>
    )
    return (
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="space-between">
        <Grid item>{playBtn}</Grid>
        <Grid item>
          <Button
            disabled={
              disabled ||
              !transaction.sale_id ||
              !transaction.pool.id_sale_product_detail
            }
            className={classes.button}
            onClick={this.handleTransfertClick}
            variant="raised"
            color="primary">
            <SwapIcon color="inherit" />
          </Button>
        </Grid>
        <Grid item>
          <Button
            disabled={
              !transaction.sale_id || !transaction.pool.id_sale_product_detail
            }
            className={classes.button}
            onClick={this.handlePaymentClick}
            variant="raised"
            color="primary">
            <ReceiptIcon color="inherit" />
          </Button>
        </Grid>
        <Grid item>
          <Button
            disabled={disabled}
            className={classes.button}
            variant="raised"
            onClick={this.addCycle}
            color="primary">
            <AlarmAdd color="inherit" />
          </Button>
        </Grid>
        {!transaction.products && !transaction.payments ? (
          <Grid item>
            <Button
              disabled={
                disabled ||
                !transaction.sale_id ||
                !transaction.pool.id_sale_product_detail
              }
              className={classes.button}
              variant="raised"
              onClick={this.cancelTransaction}
              color="secondary">
              <DeleteIcon color="inherit" />
            </Button>
          </Grid>
        ) : null}
      </Grid>
    )
  }
}

export default withStyles(styles)(ActionsTableComponent)



// WEBPACK FOOTER //
// ./src/routes/Table/components/ActionsTableComponent.js